<template>
  <section :class="getComponentClass(blok, animationClass)">
    <div class="container">
      <div class="row">
        <h3 v-if="blok.title" class="awards__title col-12">
          {{ blok.title }}
        </h3>
      </div>

      <div class="row awards__content">
        <ul class="awards-list">
          <li
            v-for="award in blok.logos"
            :key="award.id"
            class="awards-list__item"
          >
            <img
              v-if="award.filename && isSvgFile(award.filename)"
              :src="award.filename"
              :alt="getAltTagName(award.name, award.filename)"
              class="awards-list__item-image"
            />
            <component
              :is="'a_imageSource' | dashify"
              v-if="award.filename && !isSvgFile(award.filename)"
              :blok="award"
              :image-url="award.filename"
              :alt="getAltTagName(award.name, award.filename)"
              modifier-class="awards-list__item-image"
            />
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Awards',
  props: {
    blok: {
      type: Object,
      default: () => {},
    },
    visible: {
      type: Boolean,
      default: () => false,
    },
    visibleSectionIndex: {
      type: Number,
      default: () => 1000,
    },
  },
  data() {
    return {
      animationClass: 'awards--animate',
      isAnimationActive: true,
    }
  },
  computed: {
    filteredMobileAwards() {
      return []
    },
  },
  watch: {
    visible(visible) {
      if (visible) {
        this.$store.commit(
          'globals/setVisibleSectionName',
          this.blok.breadcrumb
        )
        this.$store.commit(
          'globals/setVisibleSectionIndex',
          this.visibleSectionIndex
        )
        if (this.isAnimationActive) {
          this.animationClass = 'awards--animate awards--animate-done'
          this.isAnimationActive = false
        }
      }
    },
  },
  methods: {
    getComponentClass(blok, animationClass) {
      const shadow = blok.hasShadow ? ' awards--shadow' : ''
      const height = blok.isHScreen ? ' h-screen' : 'h-default'
      const space = blok.space ? `space--${blok.space}` : 'space--small'
      return `awards theme-light ${shadow} ${height} ${space} ${animationClass}`
    },
    isSvgFile(file) {
      return file.split('.').pop() === 'svg'
    },
    getAltTagName(title, url) {
      if (title) {
        return title
      }
      const fileName = url.split('/')
      const fileNameNoExtension = fileName[fileName.length - 1].split('.')[0]
      title = fileNameNoExtension.replace('award-', '').replace('-', ' ')
      return title.charAt(0).toUpperCase() + title.slice(1)
    },
  },
}
</script>

<style lang="scss">
@import '../../assets/scss/settings';

.awards {
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;

  &.h-default {
    min-height: 0;
  }

  &--shadow {
    overflow: hidden;
    &::before {
      @extend %block-shadow;
    }
  }

  &--animate {
    .awards__title {
      opacity: 0;
      transform: translate(0, 30px);
      transition: all 0.6s cubic-bezier(0.7, 0, 0.3, 1) 0.1s;
    }

    .awards__content {
      opacity: 0;
      transition: opacity 0.7s;
      transition-delay: 0.4s;
    }
  }

  &--animate-done {
    .awards__title {
      transform: translate(0, 0);
      opacity: 1;
    }
    .awards__content {
      opacity: 1;
    }
  }

  &__title {
    @include font-family($font-family-headings-bold, $headings-font-weight);
    @include font-size(36);

    margin-top: 0;
    margin-bottom: spacer(2);
  }

  &-list {
    width: 100%;
    margin: 10px;
    padding: 0;
    list-style: none;

    &__item {
      display: inline-block;
      margin: 0;
      padding: 35px;
      width: 50%;

      &-image {
        width: 100%;
        height: auto;
      }
    }
  }
}

@include media-breakpoint-up(md) {
  .awards {
    .awards-list__item {
      width: 25%;
    }
  }
}

@include media-breakpoint-up(lg) {
  .awards {
    .awards-list__item {
      width: 16.5%;
    }
  }
}
</style>
